/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always uses your official Mojang UUID and synchronizes skins/capes, even when joining via offline launchers.`)
};

const zh_hans1_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无论使用正版还是离线启动器，均统一使用您的正版 UUID 并同步正版皮肤/披风，共享同一套正版存档。`)
};

const zh_hant1_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無論使用正版還是離線啟動器，均統一使用您的正版 UUID 並同步正版皮膚/披風，共用同一套正版存檔。`)
};

const fr_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilise toujours votre UUID Mojang officiel et synchronise vos skins/capes, même via un lanceur hors ligne.`)
};

const de_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwendet immer Ihre offizielle Mojang-UUID und synchronisiert Skins/Capes, auch bei Offline-Starts.`)
};

const ja_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインランチャーから接続した場合でも、公式Mojang UUIDを使用し、公式スキンやマントを同期します。`)
};

const ko_settings_minecraft_mode_mojang_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오프라인 런처로 접속하더라도 항상 공식 Mojang UUID를 사용하며 스킨/망토를 동기화합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_mode_mojang_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_mode_mojang_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_mode_mojang_desc", locale)
	if (locale === "en") return en_settings_minecraft_mode_mojang_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_mode_mojang_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_mode_mojang_desc(inputs)
	if (locale === "fr") return fr_settings_minecraft_mode_mojang_desc(inputs)
	if (locale === "de") return de_settings_minecraft_mode_mojang_desc(inputs)
	if (locale === "ja") return ja_settings_minecraft_mode_mojang_desc(inputs)
	return ko_settings_minecraft_mode_mojang_desc(inputs)
};